module.exports = __webpack_public_path__ + "img/robot-hand.fbe7da47.png";